export default __webpack_public_path__ + "static/media/kgv-image-01.69f1b88f.jpg";